<template>
  <div v-if="path && path.length">
    <div
      v-for="(step, idx) in path"
      :key="idx"
      class="small mb-1"
    >
      <span
        v-if="step.error"
        class="text-danger"
      >Error: {{ step.error }}</span>
      <span
        v-else-if="step.info"
        class="text-muted"
      >{{ step.reason || step.info }}</span>
      <span
        v-else
        class="d-flex align-items-start gap-2"
      >
        <span class="badge rounded-pill bg-primary-subtle text-primary-emphasis">{{ idx + 1 }}</span>
        <span>
          <span class="fw-medium">{{ step.nodeName || `Node ${step.nodeId}` }}</span>
          <span class="text-muted">
            — {{ step.field }} = "{{ step.fieldValue }}" {{ step.operator }} {{ formatThreshold(step.threshold) }}
          </span>
          <span
            class="badge ms-2"
            :class="step.result ? 'bg-success' : 'bg-danger'"
          >{{ step.branch }}</span>
          <span
            v-if="step.jumpToTreeId"
            class="badge bg-secondary ms-2"
          >→ Decision Tree #{{ step.jumpToTreeId }}</span>
        </span>
      </span>
    </div>
  </div>
  <span
    v-else
    class="text-muted small"
  >No path data</span>
</template>

<script>
export default {
  props: { path: { type: Array, default: () => []}},
  methods: {
    formatThreshold(v) {
      if (Array.isArray(v)) {
        return `[${v.join(', ')}]`;
      }
      return String(v ?? '');
    },
  },
};
</script>
